var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileMovBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Canvas",
    transform: "translate(10848 -935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__file-mov-bw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path0_fill",
    transform: "matrix(1 0 0 -1 -10836 966.368)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path1_fill",
    transform: "matrix(1 0 0 -1 -10831.5 974.665)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "file-mov-bw_svg__file-mov-bw_svg__mask0_alpha",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__mask0_outline_ins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path1_fill",
    transform: "matrix(1 0 0 -1 -10831.5 974.665)",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Group",
    mask: "url(#file-mov-bw_svg__file-mov-bw_svg__mask0_alpha)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -10832.3 975.527)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10828.7 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10828.7 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10828.7 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10828.7 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10816.4 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10816.4 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10816.4 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -10816.4 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10828.7 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -10816.4 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -10824.2 968.189)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__file-mov"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Canvas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__mov"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path8_fill",
    transform: "translate(-10848 935)",
    fill: "#D9DEE0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mov-bw_svg__file-mov-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mov-bw_svg__file-mov-bw_svg__path9_fill",
    transform: "translate(-10835.6 978.541)",
    fill: "#FFFFFF"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path0_fill",
    d: "M 2.00509 0.771819L 5.80639 0L 17.8304 9.4341L 18.1269 10.2382C 18.3157 10.8901 18.2078 11.5942 17.8304 12.168C 17.4799 12.7417 16.8868 13.1589 16.2128 13.3154L 5.80639 15.7667C 5.61769 15.8189 5.40202 15.845 5.18635 15.845C 4.70107 15.845 4.24276 15.7146 3.81139 15.4799C 3.21828 15.1409 2.78692 14.5672 2.62517 13.9152L 0.0909576 3.84904C -0.0977599 3.19709 0.0100785 2.49298 0.387514 1.91926C 0.73799 1.34554 1.3311 0.92829 2.00509 0.771819Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path1_fill",
    d: "M 2.97151 0L 16.6405 0C 18.267 0 19.612 1.31411 19.612 2.97238L 19.612 16.6453C 19.612 18.2723 18.2983 19.6177 16.6405 19.6177L 2.97151 19.6177C 1.345 19.6177 0 18.3036 0 16.6453L 0 2.97238C 0 1.3454 1.31372 0 2.97151 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path2_fill",
    d: "M 17.5026 -2.61531e-09L 3.8337 -2.61531e-09L 3.8337 1.72439L 17.5026 1.72439L 17.5026 -2.61531e-09ZM 3.8337 -2.61531e-09C 1.6936 -2.61531e-09 -2.61531e-09 1.73757 -2.61531e-09 3.83458L 1.72439 3.83458C 1.72439 2.6776 2.65823 1.72439 3.8337 1.72439L 3.8337 -2.61531e-09ZM -2.61531e-09 3.83458L -2.61531e-09 17.5075L 1.72439 17.5075L 1.72439 3.83458L -2.61531e-09 3.83458ZM -2.61531e-09 17.5075C -2.61531e-09 19.6477 1.7367 21.3421 3.8337 21.3421L 3.8337 19.6177C 2.67769 19.6177 1.72439 18.684 1.72439 17.5075L -2.61531e-09 17.5075ZM 3.8337 21.3421L 17.5026 21.3421L 17.5026 19.6177L 3.8337 19.6177L 3.8337 21.3421ZM 17.5026 21.3421C 19.6428 21.3421 21.3364 19.6046 21.3364 17.5075L 19.612 17.5075C 19.612 18.6645 18.6781 19.6177 17.5026 19.6177L 17.5026 21.3421ZM 21.3364 17.5075L 21.3364 3.83458L 19.612 3.83458L 19.612 17.5075L 21.3364 17.5075ZM 21.3364 3.83458C 21.3364 1.69446 19.5997 -2.61531e-09 17.5026 -2.61531e-09L 17.5026 1.72439C 18.6587 1.72439 19.612 2.65814 19.612 3.83458L 21.3364 3.83458Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path3_fill",
    d: "M 1.5367 0L 0 0L 0 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path4_fill",
    d: "M 1.5367 0L 0 0L 0 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path5_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path6_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path7_fill",
    d: "M 0.296556 6.58474C 0.242636 6.58474 0.188717 6.58474 0.161758 6.55864C 0.0539188 6.50652 -6.34803e-15 6.40219 -6.34803e-15 6.29787L -6.34803e-15 0.299899C -6.34803e-15 0.195586 0.0539188 0.0912734 0.161758 0.0391173C 0.269596 -0.0130391 0.377435 -0.0130391 0.458315 0.0391173L 5.49978 3.03811C 5.58064 3.09026 5.63458 3.19457 5.63458 3.29889C 5.63458 3.4032 5.58064 3.48144 5.49978 3.55967L 0.458315 6.53258C 0.404395 6.55864 0.350475 6.58474 0.296556 6.58474Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path8_fill",
    d: "M 35.7148 0L 3.57078 0C 1.60081 0 -1.60235e-16 1.55103 -1.60235e-16 3.46966L -1.60235e-16 58.5993C -1.60235e-16 60.5159 1.60081 62.069 3.57078 62.069L 46.4293 62.069C 48.4034 62.069 50 60.5159 50 58.5993L 50 13.8786L 35.7148 0ZM 35.7148 4.90552L 44.9512 13.8786L 35.7148 13.8786L 35.7148 4.90552ZM 46.43 58.5993L 3.57078 58.5993L 3.57078 3.46966L 32.1433 3.46966L 32.1433 13.8786C 32.1433 15.7952 33.7405 17.3483 35.7141 17.3483L 46.4293 17.3483L 46.4293 58.5993L 46.43 58.5993Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mov-bw_svg__file-mov-bw_svg__path9_fill",
    d: "M 7.55172 0.103448C 7.70345 0.103448 7.83104 0.155172 7.93448 0.258621C 8.03793 0.362069 8.08966 0.489655 8.08966 0.641379L 8.08966 7.64483C 8.08966 7.79655 8.03448 7.92414 7.92414 8.02759C 7.82069 8.13103 7.69655 8.18276 7.55172 8.18276C 7.4 8.18276 7.27241 8.13103 7.16897 8.02759C 7.06552 7.92414 7.01379 7.79655 7.01379 7.64483L 7.01379 2.50345L 4.51034 7.60345C 4.3931 7.78276 4.23793 7.87241 4.04483 7.87241C 3.81724 7.87241 3.65172 7.76552 3.54828 7.55172L 1.07586 2.59655L 1.07586 7.64483C 1.07586 7.79655 1.02414 7.92414 0.92069 8.02759C 0.817241 8.13103 0.689655 8.18276 0.537931 8.18276C 0.386207 8.18276 0.258621 8.13103 0.155172 8.02759C 0.0517242 7.92414 -1.46669e-08 7.79655 -1.46669e-08 7.64483L -1.46669e-08 0.641379C -1.46669e-08 0.489655 0.0517242 0.362069 0.155172 0.258621C 0.258621 0.155172 0.386207 0.103448 0.537931 0.103448C 0.744828 0.103448 0.903448 0.2 1.01379 0.393103L 4.08621 6.54828L 7.07586 0.393103C 7.18621 0.2 7.34483 0.103448 7.55172 0.103448ZM 13.8975 8.28621C 13.0975 8.28621 12.3837 8.11034 11.7561 7.75862C 11.1354 7.4069 10.6526 6.91724 10.3078 6.28966C 9.96298 5.65517 9.79057 4.93793 9.79057 4.13793C 9.79057 3.33793 9.96298 2.62414 10.3078 1.99655C 10.6526 1.36897 11.1354 0.87931 11.7561 0.527586C 12.3837 0.175862 13.0975 1.39763e-08 13.8975 1.39763e-08C 14.6906 1.39763e-08 15.3976 0.175862 16.0182 0.527586C 16.6458 0.87931 17.132 1.36897 17.4769 1.99655C 17.8286 2.62414 18.0044 3.33793 18.0044 4.13793C 18.0044 4.93793 17.8286 5.65517 17.4769 6.28966C 17.132 6.91724 16.6493 7.4069 16.0286 7.75862C 15.4079 8.11034 14.6975 8.28621 13.8975 8.28621ZM 13.8975 7.31379C 14.4837 7.31379 15.0113 7.17586 15.4803 6.9C 15.9493 6.61724 16.3148 6.23448 16.5769 5.75172C 16.8389 5.26897 16.97 4.73103 16.97 4.13793C 16.97 3.54483 16.8389 3.0069 16.5769 2.52414C 16.3148 2.04138 15.9493 1.66207 15.4803 1.38621C 15.0182 1.11034 14.4906 0.972414 13.8975 0.972414C 13.3044 0.972414 12.7733 1.11034 12.3044 1.38621C 11.8423 1.66207 11.4802 2.04138 11.2182 2.52414C 10.9561 3.0069 10.8251 3.54483 10.8251 4.13793C 10.8251 4.73103 10.9561 5.26897 11.2182 5.75172C 11.4802 6.23448 11.8457 6.61724 12.3147 6.9C 12.7837 7.17586 13.3113 7.31379 13.8975 7.31379ZM 25.4851 0.103448C 25.6369 0.103448 25.7539 0.144828 25.8367 0.227586C 25.9265 0.310345 25.9713 0.417241 25.9713 0.548276C 25.9713 0.631035 25.9505 0.72069 25.9093 0.817241L 22.847 7.84138C 22.7574 8.06897 22.5953 8.18276 22.361 8.18276C 22.1401 8.18276 21.9782 8.06897 21.8748 7.84138L 18.8438 0.910345C 18.7884 0.765517 18.7608 0.644828 18.7608 0.548276C 18.7608 0.410345 18.8024 0.303448 18.8851 0.227586C 18.9746 0.144828 19.0953 0.103448 19.2472 0.103448C 19.4886 0.103448 19.6539 0.210345 19.7438 0.424138L 22.3507 6.67241L 24.9989 0.424138C 25.047 0.3 25.1093 0.217241 25.185 0.175862C 25.2608 0.127586 25.3608 0.103448 25.4851 0.103448Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMovBw);
export default __webpack_public_path__ + "static/media/file-mov-bw.b014c06234f915134b89d49d8dfb6814.svg";
export { ForwardRef as ReactComponent };